import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { userActions } from "../../../actions/user.actions";
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Form,
  FormGroup,
  Button,
  Input,
} from "reactstrap";
import axiosInstance from '../../../helpers/axios';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import credit5 from "../../../assets/images/Credit5.png";
import debit5 from "../../../assets/images/debit5.png";
import passed from "../../../assets/images/passed.png";
import fraud from "../../../assets/images/fraud.png";
import remove from "../../../assets/images/delete_rm.png";
import fraudCheck from "../../../assets/images/fraudCheck.png";
import uploadPdf from "../../../assets/images/uploadPdf.svg";
import frame from "../../../assets/images/Frame.png";
import averageEod from "../../../assets/images/averageEod.png";
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import Typography from '@mui/material/Typography';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import DatePicker from "react-multi-date-picker";
import calender from "../../../assets/images/calender.png";
import { useCurrentUser } from '../../../hooks/useCurrentUser';
import { appContextConstants } from '../../../constants/appContext.constants';
import CircularProgress from '@mui/material/CircularProgress';
import Box from '@mui/material/Box';
import {
  Chart as ChartJS,
  LinearScale,
  ArcElement,
  CategoryScale,
  BarElement,
  PointElement,
  LineElement,
  Legend,
  Tooltip,
  LineController,
  BarController,
} from "chart.js";
import loans from "../../../assets/images/loans.png";
import { Chart, Bar } from "react-chartjs-2";
import "./index.css";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from "@mui/material";
import TransactionTable from "./TransactionTable/TransactionTable";
import BsiIntelligence from "./BsiIntelligence/BsiIntelligence";
import LoanObligationsView from "./BsiIntelligence/LoanObligationsView";
import { SourceChip } from "./AACards/AnalyticsSource";
import reset from "../../../assets/images/reset.png";

ChartJS.register(
  ArcElement,
  LinearScale,
  CategoryScale,
  BarElement,
  PointElement,
  LineElement,
  Legend,
  Tooltip,
  LineController,
  BarController
);

export default function IncomeProfile({
  appId,
  userId,
  kycDetails,
  bankVerificationDetails,
  profileDetails, foirRefData,
  shouldFetchData = true,
  isCoapplicant = false
}) {
  const [pdfUploadStatus, setPdfUploadStatus] = useState("");
  const navigate = useNavigate()
  const decode = useCurrentUser();
  const user = null;
  const dispatch = useDispatch();
  const uploadState = useSelector(
    (state) => state?.POSTINCOMEPDF?.postIncomePdfData?.res?.data?.data
  );
  const incomeProfileState = useSelector(
    (state) => state?.GETINCOMEPROFILE?.getIncomePdfData
  );
  const getFoirState = useSelector(
    (state) => state?.GETFOIRDETAILS?.getFoirDetails
  );
  const { status: applicationStatus } = useSelector(state => state.appContext);

  const [openRemarks, setOpenAddRemarks] = useState(false);
  const [remarks, setRemarks] = useState(null);
  const [income, setIncome] = useState(null);
  const [rent, setRent] = useState(null);
  const [emi, setEmi] = useState(null);
  const [maxEmiAmount, setMaxEmiAmount] = useState(null);
  const [minEmiAmount, setMinEmiAmount] = useState("");

  const [loanLimitMode, setLoanLimitMode] = useState(1); // 1 = Direct, 2 = Range
  const [directLoanAmount, setDirectLoanAmount] = useState("");
  const [directTenure, setDirectTenure] = useState("");
  const [isSubmittingLoanLimit, setIsSubmittingLoanLimit] = useState(false);
  const [rangePreviewStatus, setRangePreviewStatus] = useState("idle"); // idle | loading | success | error
  const [rangePreviewOptions, setRangePreviewOptions] = useState([]);
  const [rangePreviewError, setRangePreviewError] = useState("");
  const rangeRequestIdRef = React.useRef(0);

  const [courseFeesFoir, setCourseFeesFoir] = useState(null);
  const [tenureFoir, setTenureFoir] = useState(null);
  const [feemonkEmi, setFeemonkEmi] = useState(null);
  const [openAddFoir, setOpenAddFoir] = useState(false);
  const [openLoanLimit, setOpenLoanLimit] = useState(false);
  const [incomeProfileData, setIncomeProfileData] = useState(null)
  const [selectedIndex, setSelectedIndex] = useState(0);
  const [loading,setLoading] = useState(false)
  const [financialData, setFinancialData] = useState(null);


  const urlIncomeProfile = `/bank-statement-analysis/finbox/admin-analytics-data/all?userId=${userId}&applicationId=${appId}`;

  const getSanctionEmiFoirRefUrl = `admin/application/sanction-emi?applicationId=${appId}`;


  React.useEffect(() => {
    if (!isCoapplicant&&applicationStatus !== "In Review" && applicationStatus !== "In Submission") {
      const feemonkEmiFetch = async () => {
        const feemonkEmiFetched = await feemonkEMiFromSanctionDetailsApi();
        setFeemonkEmi(feemonkEmiFetched);

      }
      feemonkEmiFetch()

    }
  }, []);

  useEffect(() => {
    if (!appId) return;
    axiosInstance
      .get(`/admin/application/additional-info/financial?applicationId=${appId}`, {
      })
      .then((res) => {
        setFinancialData(res?.data?.data);
      })
      .catch((err) => {
        console.error("Failed to fetch financial data:", err);
      });
  }, [appId]);

  useEffect(() => {

    const controller = new AbortController();

    const fetchData = async () => {
      if (!shouldFetchData) return;  
      setLoading(true);
      try {
        const [incomeResponse] = await Promise.all([
          axiosInstance.get(urlIncomeProfile, {
            signal: controller.signal,
          }),
        ]);
        setIncomeProfileData(incomeResponse?.data?.data);
        setLoading(false)
      } catch (err) {
        if (err.name !== 'CanceledError') {
          console.error("Failed to fetch data:", err);
        }
      } finally {
        setLoading(false);
      }
    };

    fetchData();

    return () => {
      controller.abort();
    };

  }, [user, urlIncomeProfile, shouldFetchData]);
  const [recommendedEmiDate, setRecommendedEmiDate] = useState(null);

  const calculateRecommendedEmiDate = () => {
    const salaryDates = incomeProfileData?.[selectedIndex]?.salary || [];

    if (salaryDates.length === 0) {
      setRecommendedEmiDate(null);
      return null;
    }

    const days = salaryDates.map(item => {
      const date = new Date(item.date);
      return date.getDate();
    });

    const dayFrequency = {};
    days.forEach(day => {
      dayFrequency[day] = (dayFrequency[day] || 0) + 1;
    });

    const mostCommonDay = parseInt(
      Object.keys(dayFrequency).reduce((a, b) =>
        dayFrequency[a] > dayFrequency[b] ? a : b
      )
    );

    let emiDate;

    if (mostCommonDay >= 1 && mostCommonDay <= 3) {
      emiDate = 5;
    } else if (mostCommonDay >= 4 && mostCommonDay <= 8) {
      emiDate = 10;
    } else if (mostCommonDay >= 9 && mostCommonDay <= 13) {
      emiDate = 15;
    } else if (mostCommonDay >= 14 && mostCommonDay <= 18) {
      emiDate = 20;
    } else if (mostCommonDay >= 19 && mostCommonDay <= 23) {
      emiDate = 25;
    } else if (mostCommonDay >= 24 && mostCommonDay <= 31) {
      emiDate = 1;
    }

    setRecommendedEmiDate(emiDate);
    return emiDate;
  };

  useEffect(() => {
    if (incomeProfileData?.[selectedIndex]?.salary) {
      calculateRecommendedEmiDate();
    }
  }, [incomeProfileData, selectedIndex]);
  const displayData = incomeProfileData?.[selectedIndex] || {};

  const lastThreeEmiTransactions = ((incomeProfileData?.[selectedIndex]?.lenderDebit) ? (incomeProfileData?.[selectedIndex]?.lenderDebit)?.filter((r) => r?.transaction_note === "Total").slice(-3) : [])

  const salaryTransactions = displayData?.salary || [];
  const salaryStats = React.useMemo(() => {
    if (!salaryTransactions || salaryTransactions.length === 0) {
      return { max: 0, min: 0, avg: 0, sum: 0, count: 0 };
    }
    const amounts = salaryTransactions.map((s) => Number(s?.amount || 0)).filter((a) => !isNaN(a));
    const count = amounts.length;
    const sum = amounts.reduce((a, b) => a + b, 0);
    const max = Math.max(...amounts);
    const min = Math.min(...amounts);
    const avg = count > 0 ? sum / count : 0;
    return { max, min, avg, sum, count };
  }, [displayData?.salary]);

  //  foir useffect begin
  // used to auto calculate foir and post foir details on initial page load except for in review and in Submission stages
  const fetchAndProcessFoirDetails = async () => {
    try {
    

      
      dispatch({ type: appContextConstants.SET_FOIR_DATA, payload: foirRefData });

      if (applicationStatus === "In Review" || applicationStatus === "In Submission") {
        return
      }

      if (applicationStatus === "In Process" || applicationStatus === "In Sanction") {

        const feemonkEmiFetched = await feemonkEMiFromSanctionDetailsApi();

        const foir = Math.round(
          ((parseFloat(foirRefData?.rentPerMonth) +
            parseFloat(foirRefData?.emiPerMonth) +
            parseFloat(feemonkEmiFetched)) /
            parseFloat(foirRefData?.incomePerMonth)) * 100
        );

        const postFoirRefUrl = "/admin/application/additional-info";

        const data = {
          applicationId: appId,
          userId: userId,
          emiPerMonth: foirRefData?.emiPerMonth,
          incomePerMonth: foirRefData?.incomePerMonth,
          rentPerMonth: foirRefData?.rentPerMonth,
          foir: foir,
        };

        dispatch(userActions.postFoirDetails(postFoirRefUrl, data, user));
      }
    } catch (error) {
      console.error("Error fetching or processing FOIR details:", error);
    }
  };

  React.useEffect(() => {
    if (!isCoapplicant) {
    fetchAndProcessFoirDetails();
    }
  }, []);


  // foir useffect end




  // feemonk emi from get sanction details Api
  const feemonkEMiFromSanctionDetailsApi = async () => {
    try {
      const res = await axiosInstance.get(getSanctionEmiFoirRefUrl, {
        headers: {
        },
      });
      const fetchedEmi = res?.data?.data?.emi
      // Update state
      return fetchedEmi; // Return value for further use
    } catch (error) {
      return 0; // Return 0 as fallback
    }
  };

  // React.useEffect(() => {
  //   const feemonkEMiFromSanctionDetailsApi = () => {
  //     axiosInstance.get(getSanctionEmiFoirRefUrl,{
  //       headers: {
  //       },}).then((res) => {
  //         setFeemonkEmi(res?.data?.data?.emi)

  //       }).catch((error) => {
  //         ;
  //       });
  //   }

  //   feemonkEMiFromSanctionDetailsApi()
  // },[])

  //upload pdf
  const ref = React.useRef(null);
  const handleOpenUpload = () => {
    ref.current.click();
  };

  const [pdf, setPdf] = useState(null);

  const [openModal, setOpenModal] = React.useState(null);
  const [modalType, setModalType] = React.useState(null);
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [isMultipleChecked, setIsMultipleChecked] = useState(false);
  const [pdfPassword, setPdfPassword] = React.useState("");
  const [zipPassword, setZipPassword] = React.useState("");
  const [bank, setBank] = React.useState("");
  const handleUploadPdf = (event) => {
    // const urlPostIncomePdf = "/bank-statement-analysis/upload";

    // const data = new FormData();
    // data.append("file", event.target.files[0]);
    // data.append("type", "pdf");
    // data.append("userId", userId);

    // dispatch(userActions.postIncomePdf(urlPostIncomePdf, data, user));
    setPdf(event.target.files[0]);
  };
  const [isClicked, setIsClicked] = useState(false);
  const handlePdfFormSubmit = () => {

    if (!bank) {
      alert('Bank is required.');
      return;
    }

    if (fileInputs.length > 1 && !isMultipleChecked) {
      alert('Multiple Files checkbox must be checked when uploading more than one file.');
      return;
    }

    const formData = new FormData();

    formData.append('userId', userId);
    formData.append('applicationId', appId);

    if (fromDate && toDate) {
      const fromDates = fromDate;
      const dueDates = toDate;
      formData.append('date', `${fromDates}-${dueDates}`);
    } else {
      formData.append('date', '');
    }

    formData.append('multipleStatements', fileInputs.length > 1 ? true : false);

    fileInputs.forEach((file) => {
      if (file) {
        formData.append('files', file);
      }
    });

    formData.append('type', 'BSA');
    formData.append('source', '');
    formData.append('password', pdfPassword || '');
    formData.append('bank', bank || '');
    formData.append('doneBy', decode.display_name)

    // for (let pair of formData.entries()) {
    //   ;
    // }
    try {
      axiosInstance.post(
        `/bank-statement-analysis/finbox/upload/multiple`,
        formData,
        {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        }
      )
        .then((response) => {
          if (response.data.message === "success" && typeof (response.data.data) === "string") {
            alert(response.data.data)
            window.location.reload()
            setIsClicked(false)
          } else {
            alert("Uploaded Successfullly")
            window.location.reload()
            setIsClicked(false)
          }
        })
        .catch((err) => { ; setIsClicked(false) })

    } catch (error) {
      console.error('Error uploading:', error);
      setIsClicked(false)
    }

    // else{
    //   const urlPostIncomePdf = "/bank-statement-analysis/finbox/upload/multiple";

    //   const data = new FormData();
    //   data.append("file", pdf);
    //   data.append("type", "pdf");
    //   data.append("userId", userId);
    //   data.append("password", pdfPassword);
    //   data.append("applicationId", appId);
    //   data.append("Feemonk", "source");
    //   dispatch(userActions.postIncomePdf(urlPostIncomePdf, data, user));
    //   setOpenModal(false);
    //   setPdfPassword("");

    //   setTimeout(() => {
    //     window.location.reload()


    //   }, 1000);
    // }

  };

  const handleZipFormSubmit = () => {
    const urlPostIncomePdf = "/bank-statement-analysis/upload/zip";

    const data = new FormData();
    data.append("file", pdf);
    data.append("type", "pdf");
    data.append("userId", userId);
    data.append("password", pdfPassword);
    data.append("zipPassword", zipPassword);
    data.append('doneBy', decode.display_name)

    dispatch(userActions.postIncomePdf(urlPostIncomePdf, data, user));
    setOpenModal(false);
    setPdfPassword("");
    setZipPassword("");
  };

  let labelsEOD = [];

  incomeProfileData?.[selectedIndex]?.eod?.map((item, idx) => {
    labelsEOD.push(item.averageBalance);
  });

  const optionsVerticalBar = {
    responsive: true,
    maintainAspectRatio: true,

    plugins: {
      legend: {
        display: false,
      },
      title: {
        display: true,

        text: "Average EOD",
      },
    },
  };
  let labels = [];
  incomeProfileData?.[selectedIndex]?.eod?.map((item) => {
    labels.push(`${item.month} / ${item.year}`);
  });
  const dataVertical = {
    labels,

    datasets: [
      {
        data: labelsEOD,
        backgroundColor: (color) => {
          let colors = color.raw > (((feemonkEmi || feemonkEmi == 0) ? feemonkEmi : Math.round((profileDetails?.courseFees / profileDetails?.loanTenure) * 100) / 100)) ? "#23BDC0" : "red";
          return colors;
        },
      },
    ],
  };

  let summaryData = [];
  let cashDepositsSum = 0;
  for (let i = 0; i < incomeProfileData?.[selectedIndex]?.summary?.cashDeposits?.length; i++) {
    cashDepositsSum += incomeProfileData?.[selectedIndex]?.summary?.cashDeposits[i]?.amount
  }
  summaryData.push(cashDepositsSum)

  let salaryCreditSum = 0;
  for (let i = 0; i < incomeProfileData?.[selectedIndex]?.summary?.salaryCredits?.length; i++) {
    salaryCreditSum += incomeProfileData?.[selectedIndex]?.summary?.salaryCredits[i]?.amount
  }
  summaryData.push(salaryCreditSum)

  let loanCreditsSum = 0;
  for (let i = 0; i < incomeProfileData?.[selectedIndex]?.summary?.loanCredits?.length; i++) {
    loanCreditsSum += incomeProfileData?.[selectedIndex]?.summary?.loanCredits[i]?.emiAmount
  }
  summaryData.push(loanCreditsSum)

  let chequeDepositsSum = 0;
  for (let i = 0; i < incomeProfileData?.[selectedIndex]?.summary?.chequeDeposits?.length; i++) {
    chequeDepositsSum += incomeProfileData?.[selectedIndex]?.summary?.chequeDeposits[i]?.amount
  }
  summaryData.push(chequeDepositsSum)


  const dataDoughnut = {
    labels: [
      "Cash Deposits",
      "Cheque Deposits",
      "Loan Credits",
      "Salary Credits",
    ],

    datasets: [
      {
        label: "Amount",
        data: summaryData,
        backgroundColor: ["#579AFD", "#FA4B53", "#FE825B", "#23BDC0"],

        borderWidth: 1,
      },
    ],
  };

  const options = {
    maintainAspectRatio: true,

    indexAxis: "y",
    elements: {
      bar: {
        borderWidth: 1,
      },
    },
    responsive: true,
    plugins: {
      title: {
        display: true,
      },
    },
  };

  let footerCredit = [];

  incomeProfileData?.[selectedIndex]?.top5Credit?.map((item) => {
    footerCredit.push(`${item.paymentMode} - ${item.subcategory}`);
  });
  let footerDebit = [];

  incomeProfileData?.[selectedIndex]?.top5Debit?.map((item) => {
    footerDebit.push(`${item.paymentMode} - ${item.subcategory}`);
  });

  const optionsDebit = {
    maintainAspectRatio: true,

    indexAxis: "y",
    elements: {
      bar: {
        borderWidth: 1,
      },
    },
    responsive: true,
    plugins: {
      tooltip: {
        callbacks: {
          beforeTitle: function (context) {
            return `${footerDebit[context[0].dataIndex]}`;
          },
        },
      },
      title: {
        display: true,
      },
    },
  };
  const optionsCredit = {
    maintainAspectRatio: true,

    indexAxis: "y",
    elements: {
      bar: {
        borderWidth: 1,
      },
    },
    responsive: true,
    plugins: {
      tooltip: {
        callbacks: {
          beforeTitle: function (context) {
            return `${footerCredit[context[0].dataIndex]}`;
          },
        },
      },
      title: {
        display: true,
      },
    },
  };
  const optionsFoir = {
    maintainAspectRatio: true,
    indexAxis: "x",
    elements: {
      bar: {
        borderWidth: 2,
      },
    },
    responsive: true,
    scales: {
      B: {
        type: "linear",
        position: "right",
        ticks: { beginAtZero: true },
        grid: { display: false },
      },
      A: {
        position: "left",
        ticks: { beginAtZero: true },
        grid: { display: false },
      },
      x: { ticks: { beginAtZero: true } },
    },
    plugins: {
      legend: {
        position: "right",
      },
      title: {
        display: true,
      },
    },
  };

  let month = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ];

  // Helper: when a row has date === "Total", find a nearby real transaction
  // and return its month-year (e.g. "Jul 2025"). If not found, return empty string.
  const getMonthYearForTotal = (rows, idx) => {
    if (!Array.isArray(rows) || rows.length === 0) return "";
    const dateKey = 'date';
    const isTotal = rows[idx] && (rows[idx][dateKey] === "Total" || rows[idx][dateKey] === "Total Amount");

    // Prefer previous real transaction as base; if found, advance months for consecutive totals
    for (let i = idx - 1; i >= 0; i--) {
      const d = rows[i] && rows[i][dateKey];
      if (d && d !== "Total" && d !== "Total Amount") {
        // base found at i
        const baseStr = d;
        let baseDate = new Date(baseStr);
        if (isNaN(baseDate)) {
          const m = (baseStr || "").match(/(\d{4})-(\d{2})-(\d{2})/);
          if (m) baseDate = new Date(parseInt(m[1], 10), parseInt(m[2], 10) - 1, 1);
        }
        if (isNaN(baseDate)) return "";
        // count how many Total rows between base index and idx (inclusive of first total)
        let offset = 0;
        for (let j = i + 1; j <= idx; j++) {
          const v = rows[j] && rows[j][dateKey];
          if (v === "Total" || v === "Total Amount") offset++;
        }
        const monthOffset = Math.max(0, offset - 1);
        const resultDate = new Date(baseDate.getFullYear(), baseDate.getMonth() + monthOffset, 1);
        return `${month[resultDate.getMonth()]} ${resultDate.getFullYear()}`;
      }
    }

    // If no previous real transaction, try next and go backwards
    for (let i = idx + 1; i < rows.length; i++) {
      const d = rows[i] && rows[i][dateKey];
      if (d && d !== "Total" && d !== "Total Amount") {
        const baseStr = d;
        let baseDate = new Date(baseStr);
        if (isNaN(baseDate)) {
          const m = (baseStr || "").match(/(\d{4})-(\d{2})-(\d{2})/);
          if (m) baseDate = new Date(parseInt(m[1], 10), parseInt(m[2], 10) - 1, 1);
        }
        if (isNaN(baseDate)) return "";
        // distance from idx to this next real record
        const dist = i - idx;
        const resultDate = new Date(baseDate.getFullYear(), baseDate.getMonth() - dist, 1);
        return `${month[resultDate.getMonth()]} ${resultDate.getFullYear()}`;
      }
    }

    return "";
  };

  const getDisplayDate = (row, idx, rows) => {
    if (!row) return "";
    if (row.date === "Total" || row.date === "Total Amount") {
      const my = getMonthYearForTotal(rows, idx);
      row.yearMonthForTotal = my?my:"";
      return my ? my : "";
    }
    try {
      return new Date(row.date).toLocaleDateString("en-GB");
    } catch (e) {
      return row.date;
    }
  };

  function formatNumberWithCommas(number) {
    return number.toLocaleString('en-IN');
  }

  let top5CreditLabels = [];
  incomeProfileData?.[selectedIndex]?.top5Credit?.map((item) => {
    top5CreditLabels.push(
      `${month[parseInt(item.date.substr(5, 7))]
      } ${item.date.substr(0, 4)}`
    );
  });
  let top5Amount = [];
  incomeProfileData?.[selectedIndex]?.top5Credit?.map((item) => {
    top5Amount.push(item.amount);
  });

  const dataBarCredit = {
    labels: top5CreditLabels,
    datasets: [
      {
        label: "Amount",
        data: top5Amount,
        backgroundColor: "#23BDC0",
      },
    ],
  };
  let top5DebitLabels = [];
  incomeProfileData?.[selectedIndex]?.top5Credit?.map((item) => {
    top5DebitLabels.push(
      `${month[parseInt(item.date.substr(5, 7))]
      } ${item.date.substr(0, 4)}`
    );
  });
  let top5DebitAmount = [];
  incomeProfileData?.[selectedIndex]?.top5Credit?.map((item) => {
    top5DebitAmount.push(item.amount);
  });

  const dataBarDebit = {
    labels: top5DebitLabels,
    datasets: [
      {
        label: "Amount",
        data: top5DebitAmount,
        backgroundColor: "#FE825B",
      },
    ],
  };

  const lenderDebitAll = incomeProfileData?.[selectedIndex]?.lenderDebit || [];
  const lenderCreditAll = incomeProfileData?.[selectedIndex]?.lenderCredit || [];
  const lenderDebitCount = lenderDebitAll.filter((r) => r?.transaction_note !== "Total").length;
  const lenderCreditCount = lenderCreditAll.filter((r) => r?.transaction_note !== "Total").length;

  let foirPercentage = [];
  incomeProfileData?.[selectedIndex]?.foir?.map((item) => {
    foirPercentage.push(
      Math.round((item.totalDebitAmount / item.totalCreditAmount) * 100)
    );
  });
  let dataOutflow = [];
  incomeProfileData?.[selectedIndex]?.foir?.map((item) => {
    dataOutflow.push(Math.round(item.totalDebitAmount));
  });
  let dataInflow = [];
  incomeProfileData?.[selectedIndex]?.foir?.map((item) => {
    dataInflow.push(Math.round(item.totalCreditAmount));
  });
  const dataFoir = {
    labels,
    datasets: [
      {
        yAxisID: "B",

        type: "line",
        label: "Foir %",
        borderColor: "rgb(255, 99, 132)",
        borderWidth: 2,
        fill: false,
        data: foirPercentage,
      },
      {
        yAxisID: "A",
        type: "bar",
        label: "Outflow",
        backgroundColor: "#FE825B",
        data: dataOutflow,
        borderColor: "white",
        borderWidth: 2,
      },
      {
        yAxisID: "A",
        type: "bar",
        label: "Inflow",
        backgroundColor: "#23BDC0",
        data: dataInflow,
      },
    ],
  };
  const [checked, setChecked] = React.useState(false);

  const handleChange = (event) => {
    setChecked(event.target.checked);
  };



  const postFoirRefUrl = "/admin/application/additional-info";
  const handleSubmitFoir = () => {
    const foirKey = document.getElementById("foirValue").value;
    if (foirKey && emi && income && rent) {
      const data = {
        applicationId: appId,
        userId: userId,
        emiPerMonth: emi ? emi : 0,
        incomePerMonth: income ? income : 0,
        rentPerMonth: rent ? rent : 0,
        foir: foirKey ? foirKey : 0,
      };

      dispatch(userActions.postFoirDetails(postFoirRefUrl, data, user));
      // dispatch(userActions.getFoirDetails(getFoirRefUrl, user));
      // setTimeout(() => {
      //   window.location.reload();
      // }, 1000);
      setOpenAddFoir(!openAddFoir);
    } else alert("Fill All Details");
  };

  // Shared submit call for both loan-limit modes. Range-mode payload is not
  // yet finalized on the backend — swap this URL/body once it is, everything
  // else (validation, disabled state, reload) stays the same.
  const LOAN_LIMIT_SUBMIT_URL = "/admin/application/loan-amount";
  const submitLoanLimit = (payload) => axiosInstance.post(LOAN_LIMIT_SUBMIT_URL,  null, { params: payload });

  const handleSubmitLoanLimitDirect = () => {
    const loanAmountVal = parseFloat(directLoanAmount);
    const tenureVal = parseFloat(directTenure);
    if (
      !directLoanAmount ||
      !directTenure ||
      isNaN(loanAmountVal) ||
      isNaN(tenureVal) ||
      loanAmountVal <= 0 ||
      tenureVal <= 0
    ) {
      alert("Enter a valid Loan Amount and Tenure");
      return;
    }

    setIsSubmittingLoanLimit(true);
    submitLoanLimit({
      applicationId: appId,
      userId: userId,
      loanAmount: loanAmountVal,
      tenure: tenureVal,
      loanAmountMode: 1,
    })
      .then((res) => {
        if (res?.data?.message === "Successful") {
          alert("Updated Succesfully");
          window.location.reload();
        }
      })
      .catch(() => {
        alert("Error Updating");
      })
      .finally(() => setIsSubmittingLoanLimit(false));
  };

  const handleSubmitLoanLimitRange = () => {
    if (rangePreviewStatus !== "success") return;

    setIsSubmittingLoanLimit(true);
    submitLoanLimit({
      minimumEmiAmount: parseFloat(minEmiAmount),
      maximumEmiAmount: parseFloat(maxEmiAmount),
      applicationId: appId,
      loanAmountMode: 2
    })
      .then((res) => {
        if (res?.data?.message === "Successful") {
          alert("Updated Succesfully");
          window.location.reload();
        }
      })
      .catch(() => {
        alert("Error Updating");
      })
      .finally(() => setIsSubmittingLoanLimit(false));
  };

  const handleCloseFoir = () => {
    document.getElementById("feemonkemi").value = 0;
    document.getElementById("foirValue").value = 0;

    setRent(null)
    setEmi(null)
    setIncome(null)
    setOpenAddFoir(!openAddFoir);
    setOpenAddRemarks(!openRemarks);
  };

  const handleCloseLoanLimit = () => {
    setMaxEmiAmount(null)
    setMinEmiAmount(null)
    setLoanLimitMode(1);
    setDirectLoanAmount("");
    setDirectTenure("");
    setRangePreviewStatus("idle");
    setRangePreviewOptions([]);
    setRangePreviewError("");
    setOpenLoanLimit(!openLoanLimit);
  };

  useEffect(() => {
    if (profileDetails) {
      setMaxEmiAmount(profileDetails.maximumEmiAmount ?? "");
      setMinEmiAmount(profileDetails.minimumEmiAmount ?? "");
    }
  }, [profileDetails]);

  // Range-mode preview: debounce ~500ms after both EMI bounds are valid, then
  // fetch amount/tenure options. A request id guards against a stale response
  // (from rapid typing or mode switching) overwriting a newer one.
  useEffect(() => {
    if (!openLoanLimit || loanLimitMode !== 2) {
      return;
    }

    const minVal = parseFloat(minEmiAmount);
    const maxVal = parseFloat(maxEmiAmount);
    const hasBothValues = minEmiAmount !== "" && minEmiAmount != null && maxEmiAmount !== "" && maxEmiAmount != null;
    const isValidRange = hasBothValues && !isNaN(minVal) && !isNaN(maxVal) && minVal > 0 && maxVal > 0 && maxVal >= minVal;

    if (!isValidRange) {
      rangeRequestIdRef.current += 1; // invalidate any in-flight fetch
      setRangePreviewStatus("idle");
      setRangePreviewOptions([]);
      setRangePreviewError(hasBothValues && maxVal < minVal ? "Maximum EMI must be greater than or equal to Minimum EMI" : "");
      return;
    }

    setRangePreviewStatus("loading");
    setRangePreviewError("");

    const requestId = ++rangeRequestIdRef.current;
    const timer = setTimeout(() => {
      const url = `${process.env.REACT_APP_BASE_URL}/admin/application/loan-amount-for-emis?userId=${userId}&applicationId=${appId}&minEmi=${minVal}&maxEmi=${maxVal}`;
      axiosInstance
        .get(url)
        .then((res) => {
          if (rangeRequestIdRef.current !== requestId) return; // stale response, ignore
          const data = res?.data?.data;
          const options = data?.options || [];
          if (res?.data?.message !== "Successful" || data?.showSlider === false || options.length === 0) {
            setRangePreviewStatus("error");
            setRangePreviewOptions([]);
            setRangePreviewError("No loan options available for this EMI range.");
            return;
          }
          setRangePreviewOptions(options);
          setRangePreviewStatus("success");
        })
        .catch(() => {
          if (rangeRequestIdRef.current !== requestId) return;
          setRangePreviewStatus("error");
          setRangePreviewOptions([]);
          setRangePreviewError("Failed to fetch loan options. Please try again.");
        });
    }, 500);

    return () => clearTimeout(timer);
  }, [minEmiAmount, maxEmiAmount, loanLimitMode, openLoanLimit, userId, appId]);

  // const handleChangeFMCourse=(e)=>{

  //   setCourseFeesFoir(e.target.value)
  //   document.getElementById("feemonkemi").value=e.target.value/tenureFoir
  //   setFeemonkEmi(document.getElementById("feemonkemi").value);
  // }
  const handleChangeFMTenure = (e) => {
    document.getElementById("feemonkemi").value =
      Math.round(
        (profileDetails?.courseFees / e.target.value) *
        100
      ) / 100;

    setFeemonkEmi(document.getElementById("feemonkemi").value);
  };
  const [fileInputs, setFileInputs] = useState([null]);

  const handleAddFileInput = () => {
    setFileInputs([...fileInputs, null]);
  };

  const handleRemoveFileInput = (index) => {
    setFileInputs(fileInputs.filter((_, i) => i !== index));
  }; const [excelPath, setExcelPath] = useState(null)
  const excelDownload = (input) => {
    const url = `/file/url-content?path=${input.split(".com/")[1]}`
    axiosInstance
      .get(url, {
        headers: {
        },
      })
      .then((res) => {
        setExcelPath(res?.data?.data)
        window.open(res?.data?.data, "_blank")
      })
      .catch((err) => {
      })
  }
  const [confirmationModal, setConfirmationModal] = useState(false)
  const toggleConfirmationModal = () => {
    setConfirmationModal(!confirmationModal)
  }

  const handleReset = () => {
    const url = "/bank-sdk/reset"
    const body = {
      userId: userId,
      applicationId: appId
    }

    axiosInstance.post(url, body, {
      headers: {
      }
    })

      .then((res) => {
        if (res?.data?.message === "success") {
          alert("Reset Successful")
          window.location.reload()
        }
      })
      .catch((err) => {
        alert("error in resetting")
      })

  }

  return (
    <>
      {/* Modals and Dialogs should be at the top level, their visibility controlled by state */}
      <Modal isOpen={confirmationModal} toggle={toggleConfirmationModal} backdrop="static" style={{ top: '10%' }}>
        <ModalHeader toggle={toggleConfirmationModal}>Reset Statement(PDF)</ModalHeader>
        <ModalBody>
          <p style={{ fontFamily: 'Inter-Medium', textAlign: 'center' }}> Are You Sure, Click <span style={{ fontFamily: 'Inter-Medium', fontWeight: 'bold' }}>OK</span> to continue.{" "}
          </p>
          <div style={{ display: 'flex', justifyContent: 'space-between' }}>
            <button style={{ backgroundColor: 'gray', color: 'white', paddingLeft: '10px', paddingRight: '10px', borderRadius: '10px' }} onClick={toggleConfirmationModal}> CANCEL</button>
            <button style={{ backgroundColor: '#d32808', color: 'white', paddingLeft: '10px', paddingRight: '10px', borderRadius: '10px' }} onClick={() => handleReset()}>OK</button>

          </div>
        </ModalBody>
      </Modal>
      <Dialog // This is your file upload modal
        style={{ marginTop: '-10%' }}
        fullWidth={true}
        open={openModal}
        onClose={() => { setOpenModal(false); setPdf(null); }}
      >
        <DialogTitle style={{ backgroundColor: "#F3F3F3" }}>
          Upload Files
        </DialogTitle>
        <DialogContent style={{ marginTop: "1em" }}>
          <div style={{ display: 'flex', justifyContent: 'space-between' }}>
            <div style={{ width: '35%' }}>
              <p style={{ lineHeight: '1em', marginTop: '0.2em' }}>Bank Name</p>
              <Input
                style={{ marginBottom: "1em" }}
                onChange={(e) => setBank(e.target.value)}
                type="text"
                placeholder="Enter Bank Name"
                value={bank}
              />
            </div>
            <div style={{ width: '40%' }}>
              <p style={{ lineHeight: '1em' }}>Select Date</p>
              <DatePicker
                style={{
                  height: '35px', borderRadius: '5px', padding: '2px', backgroundRepeat: 'no-repeat',
                  backgroundPosition: '5px center',
                  backgroundSize: '15px 15px', backgroundImage: `url(${calender})`, paddingLeft: '30px', fontSize: "14px", border: '1px solid #ccc', fontWeight: "normal", border: '1px solid #ccc'
                }}
                placeholder="Select Date range"
                allowClear={true}
                format="DD MMM YYYY"
                onChange={(dates, dateStrings) => {
                  setFromDate(dateStrings?.validatedValue[0])
                  setToDate(dateStrings?.validatedValue[1])
                }}
                range
              />
            </div>
            <div >
              <p style={{ lineHeight: '1em' }}>Multiple Files</p>
              <input type="checkbox" checked={isMultipleChecked} onChange={(e) => setIsMultipleChecked(e.target.checked)} style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', marginLeft: '1em', marginTop: '2em', cursor: 'pointer' }} />
            </div>
          </div>
          {fileInputs.map((_, index) => (
            <div key={index} style={{ display: "flex", alignItems: "center", marginBottom: "1em" }}>
              <Input
                type="file"
                onChange={(e) => {
                  const updatedInputs = [...fileInputs];
                  updatedInputs[index] = e.target.files[0];
                  setFileInputs(updatedInputs);
                }} style={{ width: '20em', marginTop: '1em' }}
              />
              {fileInputs.length > 1 && (
                <img src={remove} onClick={() => handleRemoveFileInput(index)} style={{ cursor: 'pointer', marginLeft: '1em', marginTop: '1em' }} />
              )}
            </div>
          ))}

          <Button onClick={handleAddFileInput} style={{ marginBottom: "1em" }} variant="contained" color="primary">
            Add More Files
          </Button>

          {modalType === "ZIP" && (
            <>
              <p style={{ lineHeight: '1em' }}>Zip File Password</p>
              <Input
                style={{ marginBottom: "1em" }}
                onChange={(e) => setZipPassword(e.target.value)}
                type="password"
                placeholder="Zip File Password"
                value={zipPassword}
              />
            </>
          )}
          <p style={{ lineHeight: '1em' }}> PDF File Password</p>
          <Input
            style={{ marginBottom: "1em" }}
            onChange={(e) => setPdfPassword(e.target.value)}
            type="password"
            placeholder="PDF File Password"
            value={pdfPassword}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={() => { setOpenModal(false); setPdf(null) }}>Cancel</Button>
          <Button
            style={{
              backgroundColor: isClicked ? "gray" : "#D32028", border: 'none'
            }}
            onClick={() => {
              setIsClicked(true);
              modalType === "ZIP" ? handleZipFormSubmit() : handlePdfFormSubmit();
            }}
          >
            {isClicked ? "Submitting" : "Submit"}
          </Button>
        </DialogActions>
      </Dialog>

      <Modal size="md" isOpen={openAddFoir}>
        <ModalHeader style={{ backgroundColor: "#F0F0F0" }}>
          <span style={{ fontWeight: "bold" }}>Add FOIR</span>
        </ModalHeader>
        <ModalBody>
          <Form>
            <FormGroup>
              Income
              <Input
                style={{ marginBottom: "1em" }}
                onChange={(e) => setIncome(e.target.value)}
                type="number"
                placeholder="&#8377;"
              />
              Rent
              <Input
                style={{ marginBottom: "1em" }}
                onChange={(e) => setRent(e.target.value)}
                type="number"
                placeholder="&#8377;"
              />
              EMI
              <Input
                style={{ marginBottom: "1em" }}
                onChange={(e) => setEmi(e.target.value)}
                type="number"
                placeholder="&#8377;"
              />
              {applicationStatus === "In Review" && (<>
                <p>Tenure</p>
                <Input
                  defaultValue={profileDetails?.tenure}
                  style={{ marginBottom: "1em" }}
                  onChange={(e) => handleChangeFMTenure(e)}
                  type="number"
                />
              </>)}
              {decode?.clientId === '98ffb18a-9fee-43a5-91a3-4b2b9d9ae361' ? "Bijay EMI" : "Feemonk EMI"}
              <Input
                style={{ marginBottom: "1em" }}
                defaultValue={
                  (applicationStatus === "In Review" || applicationStatus === "In Submission") ? (Math.round(
                    (profileDetails?.courseFees / profileDetails?.loanTenure) *
                    100
                  ) / 100) : ((feemonkEmi || feemonkEmi == 0) ? feemonkEmi : 0)
                }
                id="feemonkemi"
                disabled
                type="number"
                placeholder="Feemonk EMI"
              />
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-around",
                  backgroundColor: "#FCF0F1",
                  padding: "1em",
                  borderRadius: "10px",
                }}
              >
                <p style={{ color: "#d32028", marginTop: "10px" }}>
                  Calculated FOIR
                </p>
                <Input
                  style={{ width: "15em" }}
                  id="foirValue"
                  disabled
                  value={Math.round(
                    ((parseFloat(rent ? rent : 0) +
                      parseFloat(emi ? emi : 0) +
                      parseFloat((feemonkEmi || feemonkEmi == 0) ? feemonkEmi : 0)) /
                      parseFloat(income ? income : 0)) *
                    100
                  )}
                  type="number"
                  placeholder="Calculated FOIR"
                />
              </div>
            </FormGroup>
          </Form>
        </ModalBody>
        <ModalFooter>
          <Button onClick={() => handleCloseFoir()}>Close</Button>
          <Button
            style={{ backgroundColor: "#d32028", border: "none" }}
            onClick={() => handleSubmitFoir()}
          >
            Submit
          </Button>
        </ModalFooter>
      </Modal>

      <Modal size="md" isOpen={openLoanLimit}>
        <ModalHeader style={{ backgroundColor: "#F0F0F0" }}>
          <span style={{ fontWeight: "bold" }}>Set Loan Limit</span>
        </ModalHeader>
        <ModalBody>
          <div style={{ display: "flex", marginBottom: "1.5em" }}>
            <Button
              onClick={() => setLoanLimitMode(1)}
              style={{
                flex: 1,
                marginRight: "0.5em",
                backgroundColor: loanLimitMode === 1 ? "#d32028" : "#FFF",
                color: loanLimitMode === 1 ? "#FFF" : "#000",
                border: "1px solid #d32028",
              }}
            >
              Direct
            </Button>
            <Button
              onClick={() => setLoanLimitMode(2)}
              style={{
                flex: 1,
                backgroundColor: loanLimitMode === 2 ? "#d32028" : "#FFF",
                color: loanLimitMode === 2 ? "#FFF" : "#000",
                border: "1px solid #d32028",
              }}
            >
              Range
            </Button>
          </div>

          {loanLimitMode === 1 ? (
            <Form>
              <FormGroup>
                Loan Amount
                <Input
                  style={{ marginBottom: "1em" }}
                  onChange={(e) => setDirectLoanAmount(e.target.value)}
                  type="number"
                  value={directLoanAmount}
                  placeholder="&#8377;"
                />
                Tenure (months)
                <Input
                  style={{ marginBottom: "1em" }}
                  onChange={(e) => setDirectTenure(e.target.value)}
                  type="number"
                  value={directTenure}
                  placeholder="Months"
                />
              </FormGroup>
            </Form>
          ) : (
            <Form>
              <FormGroup>
                Minimum EMI Amount
                <Input
                  style={{ marginBottom: "1em" }}
                  onChange={(e) => setMinEmiAmount(e.target.value)}
                  value={minEmiAmount}
                  type="number"
                  placeholder="&#8377;"
                />
                Maximum EMI Amount
                <Input
                  style={{ marginBottom: "1em" }}
                  onChange={(e) => setMaxEmiAmount(e.target.value)}
                  type="number"
                  value={maxEmiAmount}
                  placeholder="&#8377;"
                />
              </FormGroup>

              {rangePreviewStatus === "loading" && (
                <Box style={{ display: "flex", alignItems: "center", justifyContent: "center", padding: "2em" }}>
                  <CircularProgress size={28} />
                </Box>
              )}

              {rangePreviewStatus === "error" && (
                <p style={{ color: "red", textAlign: "center" }}>{rangePreviewError}</p>
              )}

              {rangePreviewStatus === "idle" && rangePreviewError && (
                <p style={{ color: "red", textAlign: "center" }}>{rangePreviewError}</p>
              )}

              {rangePreviewStatus === "success" && (
                <TableContainer component={Paper} style={{ marginTop: "1em" }}>
                  <Table size="small" aria-label="loan amount preview table">
                    <TableHead sx={{ backgroundColor: "#F6F9FF" }}>
                      <TableRow>
                        <TableCell>Loan Amount</TableCell>
                        <TableCell align="center">Eligible Tenures (months)</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {rangePreviewOptions.map((option, idx) => (
                        <TableRow key={idx}>
                          <TableCell scope="row">&#8377;{option?.amount?.toLocaleString()}</TableCell>
                          <TableCell align="center">{(option?.tenures || []).map((t) => t?.tenure).join(", ")}</TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </TableContainer>
              )}
            </Form>
          )}
        </ModalBody>
        <ModalFooter>
          <Button onClick={() => handleCloseLoanLimit()}>Close</Button>
          <Button
            style={{ backgroundColor: "#d32028", border: "none" }}
            disabled={
              isSubmittingLoanLimit ||
              (loanLimitMode === 2 && rangePreviewStatus !== "success")
            }
            onClick={() => (loanLimitMode === 1 ? handleSubmitLoanLimitDirect() : handleSubmitLoanLimitRange())}
          >
            {isSubmittingLoanLimit ? "Submitting" : "Submit"}
          </Button>
        </ModalFooter>
      </Modal>
      {!isCoapplicant && (
 <div
            style={{
              display: "flex",
              paddingTop: "1em",
              marginTop: "2em",
              justifyContent: "space-around",
              backgroundColor: "#FFF3F3",
              border: "1px solid #D32028",
              borderRadius: "1em",
            }}
          >
            <div style={{ display: "block", lineHeight: "1em" }}>
              <p>Current Rent</p>
              <p style={{ fontWeight: "bold" }}>
              &#8377;{financialData?.rentPerMonth?.toLocaleString()}
              </p>
            </div>
            <div style={{ display: "block", lineHeight: "1em" }}>
              <p>Current Income</p>
              <p style={{ fontWeight: "bold" }}>
              &#8377;{financialData?.incomePerMonth?.toLocaleString()}
              </p>
            </div>
            <div style={{ display: "block", lineHeight: "1em" }}>
              <p>Current EMI</p>
              <p style={{ fontWeight: "bold" }}>
              &#8377;{financialData?.emiPerMonth?.toLocaleString()}
              </p>
            </div>
            <div style={{ display: "block", lineHeight: "1em" }}>
              <p>{decode?.clientId === '98ffb18a-9fee-43a5-91a3-4b2b9d9ae361' ? "Bijay EMI" : "Feemonk EMI"}</p>
              <p style={{ fontWeight: "bold" }}>
                &#8377;
                {
                  (applicationStatus === "In Review" || applicationStatus === "In Submission") ? (Math.round(
                    (profileDetails?.courseFees / profileDetails?.loanTenure) *
                    100
                  ) / 100) : ((feemonkEmi || feemonkEmi == 0) ? feemonkEmi : 0)
                }
              </p>
            </div>
            <div style={{ display: "block", lineHeight: "1em" }}>
              <p>FOIR</p>
            <p style={{ fontWeight: "bold" }}>{financialData?.foir} %</p>
            </div>

            <div style={{ display: "block", lineHeight: "1em" }}>
              <Button
                onClick={() => setOpenAddFoir(!openAddFoir)}
                style={{ backgroundColor: "#D32028", border: "none" }}
              >
                Edit FOIR
              </Button>
            </div>
            {profileDetails?.cra === "app" ? <> <div style={{ display: "block", lineHeight: "1em" }}>
              <Button
                onClick={() => setOpenLoanLimit(!openLoanLimit)}
                style={{ backgroundColor: "#D32028", border: "none" }}
              >
                Set Limits
              </Button>
            </div></> : null}

          </div>
      )}
    
      {loading ?(
        <Box style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '15%' }}>
            <CircularProgress />
        </Box>
      ):(
        <>
         {incomeProfileData && Array.isArray(incomeProfileData) && incomeProfileData.length > 0 && incomeProfileData[0]?.error ? (
        // Case 1: Display error message
        <div style={{ textAlign: 'center', padding: '20px', marginTop: '50px', color: 'red', fontSize: '1.2em' }}>
          <h2> {incomeProfileData[0].error}</h2>
          <p>Please upload a new bank statement to retry.</p>
          <Button
            style={{ backgroundColor: "#D32028", border: "none", marginTop: "1em" }}
            onClick={() => {
              setOpenModal(true);
              setModalType("PDF"); // Assume PDF is the primary upload type
            }}
          >
            Upload New Bank Statement
          </Button>
        </div>
      ) : incomeProfileData && Array.isArray(incomeProfileData) && incomeProfileData.length > 0 ? (
        // Case 2: Data is available and valid, render the full dashboard
        <div style={{ display: "block" }}> {/* This div was the outer wrapper for your original content */}
         
          <div
            style={{
              display: "flex",
              marginTop: "1em",
            }}
          >
            <div
              style={{
                flex: 1,
              }}
            >
            </div>
            {incomeProfileData?.[selectedIndex]?.nameMatchScore ? <Button style={{ fontSize: '13px', backgroundColor: '#FFF', border: '1px solid #DbDbDb', color: 'black', fontWeight: 'bold', marginRight: '10%' }}>NameMatch Score : <strong>{incomeProfileData?.[selectedIndex]?.nameMatchScore?.toFixed(2)}%</strong></Button> : null}
            {recommendedEmiDate ? <Button style={{ fontSize: '13px', backgroundColor: '#FFF', border: '1px solid #DbDbDb', color: 'black', fontWeight: 'bold', marginRight: '10%' }}>Recommended EMI Date : <strong style={{ color: 'green' }}> {recommendedEmiDate} of every month</strong></Button> : null}

            {incomeProfileData?.[selectedIndex]?.excel ? <div style={{ display: 'flex', justifyContent: 'center', marginRight: '10%' }}>
              <Button onClick={() => excelDownload(incomeProfileData?.[selectedIndex]?.excel)} style={{ fontSize: '13px', backgroundColor: '#FFF', border: '1px solid #DbDbDb', color: 'green', fontWeight: 'bold' }}>Download Bank Analysis Excel Report</Button>

            </div> : null}
            {incomeProfileData?.[selectedIndex]?.bankConnectScore ? <div style={{ display: 'flex', justifyContent: 'center', marginRight: '10%' }}>
              <Button title="Bank Statement Score by Finbox" style={{ fontSize: '13px', backgroundColor: '#FFF', border: '1px solid #DbDbDb', color: 'blue', fontWeight: 'bold' }}>Finbox Score <strong>{incomeProfileData?.[selectedIndex]?.bankConnectScore}</strong></Button>

            </div> : null}
            <div
              style={{
                display: "flex",
              }}
            >
              {profileDetails?.cra === "app" ? <span onClick={() => toggleConfirmationModal()}><img src={reset} style={{ height: '30px', marginRight: '10px', cursor: 'pointer' }} /></span> : null}
              <div>
                <img
                  onClick={() => {
                    setOpenModal(true);
                    setModalType("PDF");
                  }}
                  style={{ cursor: "pointer" }}
                  src={uploadPdf}
                />
              </div>
              {/* <div>
                <img
                  onClick={() => {
                    setOpenModal(true);
                    setModalType("ZIP");
                  }}
                  style={{ cursor: "pointer" }}
                  src={uploadZip}
                />
              </div> */}
            </div>
          </div>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            {incomeProfileData?.length > 0 ? (<>{incomeProfileData?.map((item, index) => (
              <p key={index} onClick={() => setSelectedIndex(index)} style={{
                marginTop: '1em',
                justifyContent: "space-around",
                cursor: "pointer", // Makes it clickable
                backgroundColor: selectedIndex === index ? "#F6F9FF" : "#F0F0F0",
                border: selectedIndex === index ? "1px solid #AEBBD7" : "1px solid gray",
                borderRadius: "0.5em", paddingLeft: '5px', paddingRight: '5px'
              }}>{item.bank}  {item.date}</p>
            ))}
            {!incomeProfileData?.[selectedIndex]?.error ? (
              <div style={{ marginTop: '1em', marginRight: 'auto' }}>
                <SourceChip source={incomeProfileData?.[selectedIndex]?.source} />
              </div>
            ) : null}
            </>) : null}
          </div>

          {/* BSI Intelligence Dropdown - above EOD Balance */}
          <BsiIntelligence userId={userId} appId={appId} source="finbox" />

          {/* Loan Obligations Month-wise View */}
          <LoanObligationsView incomeProfileData={incomeProfileData} selectedIndex={selectedIndex} />

          <div>
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                marginRight: "2em",
                marginLeft: "1em",
              }}
            >
              <div
                style={{
                  borderRadius: "1em",
                  width: "50%",
                  margin: "1em",
                  boxShadow: "0px 0px 2px 2px  #f0f0f0",
                }}
              >
                <div style={{ display: "flex", justifyContent: "space-around" }}>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      padding: "1em",
                      width: "100%",
                      borderBottom: "1px solid #f0f0f0",
                    }}
                  >
                    <p
                      style={{
                        fontSize: "18px",
                        fontWeight: "bold",
                        fontFamily: "Outfit",
                      }}
                    >
                      <img style={{ marginRight: "0.5em" }} src={averageEod} />
                      Average EOD Balance
                    </p>
                  </div>
                </div>
                <div style={{ padding: "1em", paddingLeft: "2em", marginTop: "2em" }}>
                  <Bar
                    redraw={true}
                    options={optionsVerticalBar}
                    data={dataVertical}
                  />
                </div>
              </div>
              <div
                style={{
                  border: "1px solid #AEBBD7",
                  borderRadius: "1em",
                  width: "50%",
                  margin: "1em",
                  backgroundColor: "#F6F9FF",
                  boxShadow: "0px 0px 2px 2px  #f0f0f0",
                }}
              >
                <div style={{ display: "flex", justifyContent: "space-around" }}>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      padding: "1em",
                      width: "100%",
                      borderBottom: "1px solid #f0f0f0",
                    }}
                  >
                    <p
                      style={{
                        fontSize: "18px",
                        fontWeight: "bold",
                        fontFamily: "Outfit",
                      }}
                    >
                      <img style={{ marginRight: "0.5em" }} src={fraudCheck} />
                      Fraud Checks
                    </p>
                  </div>
                </div>
                <div style={{ overflowY: "scroll" }}>
                  <div style={{ padding: "1em", borderBottom: "1px solid #D0D0D0" }}>
                    <p
                      style={{
                        color: "#d32028",
                        fontSize: "20px",
                        fontWeight: "bold",
                        marginLeft: "2em",
                      }}
                    >
                      Identified Fraud Indicators
                    </p>
                    {incomeProfileData?.[selectedIndex]?.flags?.bounceDetected && (
                      <p style={{ marginLeft: "2em" }}>
                        <img style={{ marginRight: "1em" }} src={fraud} />
                        Bounce Detected
                      </p>
                    )}
                    {incomeProfileData?.[selectedIndex]?.flags?.chequeBounceDetected && (
                      <p style={{ marginLeft: "2em", color: "#d32028" }}>
                        <img style={{ marginRight: "1em" }} src={fraud} />
                        Cheque Bounce Detected
                      </p>
                    )}
                    {incomeProfileData?.[selectedIndex]?.flags?.bounceDetected && (
                      <p style={{ marginLeft: "2em" }}>
                        <img style={{ marginRight: "1em" }} src={fraud} />
                        Bank Penalties Detected
                      </p>
                    )}
                    {incomeProfileData?.[selectedIndex]?.flags?.bounceDetected && (
                      <p style={{ marginLeft: "2em" }}>
                        <img style={{ marginRight: "1em" }} src={fraud} />
                        Reversal Detected
                      </p>
                    )}
                    {
                      incomeProfileData?.[selectedIndex]?.flags?.gamblingDetected && (
                        <p style={{ marginLeft: "2em" }}>
                          <img style={{ marginRight: "1em" }} src={fraud} />
                          Gambling Detected
                        </p>
                      )
                    }
                    {
                      !(incomeProfileData?.[selectedIndex]?.flags?.bounceDetected ||
                        incomeProfileData?.[selectedIndex]?.flags?.chequeBounceDetected ||
                        incomeProfileData?.[selectedIndex]?.flags?.bankPenaltiesDetected ||
                        incomeProfileData?.[selectedIndex]?.flags?.gamblingDetected) && (
                        <p style={{ marginLeft: "2em" }}>None</p>
                      )

                    }
                  </div>
                  <div style={{ padding: "1em", height: "10em" }}>
                    <p
                      style={{
                        color: "#4bb543",
                        fontSize: "20px",
                        fontWeight: "bold",
                        marginLeft: "2em",
                      }}
                    >
                      Passed Fraud Indicators
                    </p>
                    {incomeProfileData?.[selectedIndex]?.flags ? (
                      incomeProfileData?.[selectedIndex]?.flags?.bounceDetected === false ? (
                        <p style={{ marginLeft: "3em" }}>
                          <img style={{ marginRight: "1em" }} src={passed} />
                          No Bounce Detected
                        </p>
                      ) : null
                    ) : (
                      <p style={{}}>No Indicators Found</p>
                    )}
                    {incomeProfileData?.[selectedIndex]?.flags?.chequeBounceDetected === false ? (
                      <p style={{ marginLeft: "3em" }}>
                        <img style={{ marginRight: "1em" }} src={passed} />
                        No Cheque Bounce Detected
                      </p>
                    ) : null}
                    {incomeProfileData?.[selectedIndex]?.flags?.bankPenaltiesDetected === false ? (
                      <p style={{ marginLeft: "3em" }}>
                        <img style={{ marginRight: "1em" }} src={passed} />
                        No Bank Penalties Detected
                      </p>
                    ) : null}
                    {incomeProfileData?.[selectedIndex]?.flags?.gamblingDetected === false ? (
                      <p style={{ marginLeft: "3em" }}>
                        <img style={{ marginRight: "1em" }} src={passed} />
                        No Gambling Detected
                      </p>
                    ) : null}
                    {incomeProfileData?.[selectedIndex]?.flags?.reversalDetected === false ? (
                      <p style={{ marginLeft: "3em" }}>
                        <img style={{ marginRight: "1em" }} src={passed} />
                        No Reversal Detected
                      </p>
                    ) : null}
                  </div>
                </div>
              </div>
            </div>

            <Accordion style={{ width: '95%', marginLeft: '2rem', marginTop: '1em' }}>
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel1-content"
                id="panel1-header" sx={{ borderBottom: 'none' }}
              >
                <Typography component="span"> <img style={{ marginRight: "0.5em" }} src={credit5} /> Bounce Transactions ({incomeProfileData?.[selectedIndex]?.bounceTransaction?.length})</Typography>
              </AccordionSummary>
              <AccordionDetails>
                <TableContainer component={Paper}>
                  <Table sx={{ minWidth: 650 }} aria-label="simple table">
                    <TableHead sx={{ backgroundColor: '#F6F9FF' }}>
                      <TableRow>
                        <TableCell >Date</TableCell>
                        <TableCell align="center" color="red">Transaction Note</TableCell>
                        <TableCell align="center">Amount</TableCell>
                        <TableCell align="center">Description</TableCell>
                        <TableCell align="center">Transaction Type</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {incomeProfileData?.[selectedIndex]?.bounceTransaction?.length >= 1 ? (
                        <>
                          {incomeProfileData?.[selectedIndex]?.bounceTransaction.map((row) => (
                            <TableRow

                              sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                            >
                              <TableCell scope="row">
                                {(row.date).substr(0, 10)}
                              </TableCell>
                              <TableCell align="center">{row.transaction_note}</TableCell>
                              <TableCell align="center">{row.amount}</TableCell>
                              <TableCell align="center">{row?.metadata?.description}</TableCell>
                              <TableCell align="center">{row.transaction_type}</TableCell>
                            </TableRow>
                          ))}
                        </>
                      ) : <TableRow
                        sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                      >
                        <TableCell scope="row">
                          No Bounce Transactions
                        </TableCell>
                        <TableCell align="center">No Bounce Transactions</TableCell>
                        <TableCell align="center">No Bounce Transactions</TableCell>
                        <TableCell align="center">No Bounce Transactions</TableCell>
                        <TableCell align="center">No Bounce Transactions</TableCell>
                      </TableRow>}

                    </TableBody>
                  </Table>
                </TableContainer>
              </AccordionDetails>
            </Accordion>
            <Accordion style={{ width: '95%', marginLeft: '2rem', marginTop: '1em' }}>
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel1-content"
                id="panel1-header" sx={{ borderBottom: 'none' }}
              >
                <Typography component="span">
                  <img style={{ marginRight: "0.5em" }} src={debit5} />
                  Salary Profile ({salaryStats.count})
                  {salaryStats.count > 0 && (
                    <>
                      {" - "}
                      Max. Salary: {'₹' + salaryStats.max.toLocaleString()}
                      {"  |  "}
                      Min. Salary: {'₹' + salaryStats.min.toLocaleString()}
                      {"  |  "}
                      Avg. Salary: {'₹' + (Math.round(salaryStats.avg * 100) / 100).toLocaleString()}
                    </>
                  )}
                </Typography>
              </AccordionSummary>
              <AccordionDetails>
                <TableContainer component={Paper}>
                  <Table sx={{ minWidth: 650 }} aria-label="simple table">
                    <TableHead sx={{ backgroundColor: '#F6F9FF' }}>
                      <TableRow>
                        <TableCell >Date</TableCell>
                        <TableCell align="center" color="red">Transaction Note</TableCell>
                        <TableCell align="center">Amount</TableCell>
                        <TableCell align="center">Description</TableCell>
                        <TableCell align="center">Transaction Type</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                          {incomeProfileData?.[selectedIndex]?.salary?.length >= 1 ? (
                        <>
                          {incomeProfileData?.[selectedIndex]?.salary.map((row, idx) => (
                            <TableRow
                              key={idx}
                              sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                            >
                              <TableCell scope="row">
                                {getDisplayDate(row, idx, incomeProfileData?.[selectedIndex]?.salary)}
                              </TableCell>
                              <TableCell align="center">{row.transaction_note}</TableCell>
                              <TableCell align="center">{row.amount}</TableCell>
                              <TableCell align="center">{row.description}</TableCell>
                              <TableCell align="center">{row.transaction_type}</TableCell>
                            </TableRow>
                          ))}
                        </>
                      ) : <TableRow

                        sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                      >
                        <TableCell scope="row">
                          No Salary Transactions
                        </TableCell>
                        <TableCell align="center">No Salary Transactions</TableCell>
                        <TableCell align="center">No Salary Transactions</TableCell>
                        <TableCell align="center">No Salary Transactions</TableCell>
                        <TableCell align="center">No Salary Transactions</TableCell>
                      </TableRow>}

                    </TableBody>
                  </Table>
                </TableContainer>
              </AccordionDetails>
            </Accordion>
            <Accordion style={{ width: '95%', marginLeft: '2rem', marginTop: '1em' }}>
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel1-content"
                id="panel1-header" sx={{ borderBottom: 'none' }}
              >
                <Typography component="span"> <img style={{ marginRight: "0.5em", height: '1.5em' }} src={loans} /> Loan Profile (Debit : ({lenderDebitCount}) {lastThreeEmiTransactions.length > 0 && (
                          <>
                            {" "}-{" "}
                            {lastThreeEmiTransactions.map((item, index) => (
                              <Typography component="span" key={index}>
                                {item.yearMonthForTotal} : {'₹' + (item.amount ? formatNumberWithCommas(item.amount) : 0)}
                                {index !== lastThreeEmiTransactions.length - 1 && " | "}
                              </Typography>
                            ))}
                          </>
                        )} )(Credit:{lenderCreditCount} )</Typography>
              </AccordionSummary>
              <div style={{ display: 'flex' }}>
                <div style={{ width: '50%' }}>
                  <p style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', fontWeight: 'bold', fontSize: '20px' }}>Transaction Type : Debit</p>
                  <AccordionDetails>
                    <TableContainer component={Paper}>
                      <Table sx={{ width: 550 }} aria-label="simple table">
                        <TableHead sx={{ backgroundColor: '#F6F9FF' }}>
                          <TableRow>
                            <TableCell >Date</TableCell>
                            <TableCell align="center" color="red">Transaction Note</TableCell>
                            <TableCell align="center">Amount</TableCell>
                            <TableCell align="center">Category</TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                              {incomeProfileData?.[selectedIndex]?.lenderDebit?.length >= 1 ? (
                            <>
                              {incomeProfileData?.[selectedIndex]?.lenderDebit.map((row, idx) => (
                                <TableRow

                                  sx={{ '&:last-child td, &:last-child th': { border: 0 },backgroundColor:row.date==="Total"?"gray":null}}
                                >
                                  <TableCell scope="row">
                                {getDisplayDate(row, idx, incomeProfileData?.[selectedIndex]?.lenderDebit)}
                                  </TableCell>
                                  <TableCell align="center">{row.transaction_note}</TableCell>
                                  <TableCell align="center">{row.amount}</TableCell>
                                  <TableCell align="center">{(row.merchant_category === "Summary" || row.category === "Summary")? "Total" : row.merchant_category}</TableCell>
                                </TableRow>
                              ))}
                            </>
                          ) : <TableRow
                            sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                          >
                            <TableCell scope="row">
                              No Loans
                            </TableCell>
                            <TableCell align="center">No Loans</TableCell>
                            <TableCell align="center">No Loans</TableCell>
                            <TableCell align="center">No Loans</TableCell>
                          </TableRow>}

                        </TableBody>
                      </Table>
                    </TableContainer>
                  </AccordionDetails>
                </div>
                <div style={{ width: '50%' }}>
                  <p style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', fontWeight: 'bold', fontSize: '20px' }}>Transaction Type : Credit</p>
                  <AccordionDetails>
                    <TableContainer component={Paper}>
                      <Table sx={{ minWidth: 550 }} aria-label="simple table">
                        <TableHead sx={{ backgroundColor: '#F6F9FF' }}>
                          <TableRow>
                            <TableCell >Date</TableCell>
                            <TableCell align="center" color="red">Transaction Note</TableCell>
                            <TableCell align="center">Amount</TableCell>
                            <TableCell align="center">Category</TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                              {incomeProfileData?.[selectedIndex]?.lenderCredit?.length >= 1 ? (
                            <>
                              {incomeProfileData?.[selectedIndex]?.lenderCredit.map((row, idx) => (
                                <TableRow

                                  sx={{ '&:last-child td, &:last-child th': { border: 0 } ,backgroundColor:row.date==="Total"?"gray":null}}
                                >
                                  <TableCell scope="row">
                                    {getDisplayDate(row, idx, incomeProfileData?.[selectedIndex]?.lenderCredit)}
                                  </TableCell>
                                  <TableCell align="center">{row.transaction_note}</TableCell>
                                  <TableCell align="center">{row.amount}</TableCell>
                                  <TableCell align="center">{(row.merchant_category === "Summary" || row.category === "Summary")? "Total" : row.merchant_category}</TableCell>
                                </TableRow>
                              ))}
                            </>
                          ) : <TableRow
                            sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                          >
                            <TableCell scope="row">
                              No Loans
                            </TableCell>
                            <TableCell align="center">No Loans</TableCell>
                            <TableCell align="center">No Loans</TableCell>
                            <TableCell align="center">No Loans</TableCell>
                          </TableRow>}

                        </TableBody>
                      </Table>
                    </TableContainer>
                  </AccordionDetails>
                </div>
              </div>
            </Accordion>

            {/* Gambling Transactions */}
            {incomeProfileData?.[selectedIndex]?.flags?.gamblingDetected && <TransactionTable transactionData={incomeProfileData?.[selectedIndex]?.summary?.gamblingTransactions} />}

            <Accordion style={{ width: '95%', marginLeft: '2rem', marginTop: '1em' }}>
              <AccordionSummary expandIcon={<ExpandMoreIcon />}
                aria-controls="panel1-content"
                id="panel1-header" sx={{ borderBottom: 'none' }}>
                <Typography component="span"> <img style={{ marginRight: "0.5em" }} src={frame} /> FOIR Summary</Typography>
              </AccordionSummary>
              <AccordionDetails>
                <Chart
                  redraw={true}
                  options={optionsFoir}
                  type="bar"
                  data={dataFoir}
                />
              </AccordionDetails>
            </Accordion>
          </div>
        </div>
      ) : (
        // Case 3: incomeProfileData is null or empty, prompt user to upload
        <div style={{ textAlign: 'center', padding: '12px', marginTop: '50px' }}>
          <h4 style={{fontFamily:"Outfit"}}>No {decode?.clientId === '98ffb18a-9fee-43a5-91a3-4b2b9d9ae361' ? "Banking" :"Income"} Profile Data Found</h4>
          <p style={{fontFamily:"Outfit"}}>Please upload a bank statement to view the {decode?.clientId === '98ffb18a-9fee-43a5-91a3-4b2b9d9ae361' ? "banking" :"income"} profile.</p>
          <Button
            style={{ backgroundColor: "#D32028", border: "none", marginTop: "1em" }}
            onClick={() => {
              setOpenModal(true);
              setModalType("PDF");
            }}
          >
            Upload Bank Statement
          </Button>
        </div>
      )}
        </>
      )}
     
    </>
  );
}